import React, { useState, useEffect } from "react";

const ConfigPanel = ({ config, onChange, onTest, testResult, loading }) => {
  const [isCollapsed, setIsCollapsed] = useState(testResult);

  useEffect(() => {
    setIsCollapsed(testResult);
  }, [testResult]);

  const handleInputChange = (field, value) => {
    const newConfig = { ...config, [field]: value };
    onChange(newConfig);
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const getStatusText = () => {
    if (loading) return "Verbindung wird getestet...";
    return testResult ? "Verbunden" : "Nicht verbunden";
  };

  const getStatusClass = () => {
    if (loading) return "loading";
    return testResult ? "connected" : "disconnected";
  };

  // Wenn verbunden und eingeklappt, zeige nur minimierte Ansicht
  if (testResult && isCollapsed) {
    return (
      <div className="config-panel collapsed">
        <div className="config-header-collapsed" onClick={toggleCollapse}>
          <div className="collapsed-status">
            <span className={`status-indicator ${getStatusClass()}`}></span>
            <span className="status-text">{getStatusText()}</span>
          </div>
          <button
            className="collapse-toggle"
            type="button"
            title="API Konfiguration anzeigen"
          >
            <span className="toggle-arrow expanded">▼</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="config-panel">
      <div className="config-header">
        <h3>API Konfiguration</h3>
        {testResult && (
          <button
            className="collapse-toggle"
            onClick={toggleCollapse}
            type="button"
            title="API Konfiguration einklappen"
          >
            <span className="toggle-arrow">▲</span>
          </button>
        )}
      </div>

      <div className="config-row">
        {/* Account UUID */}
        <div className="form-group">
          <label htmlFor="account-uuid">Account UUID:</label>
          <input
            id="account-uuid"
            name="username"
            type="text"
            value={config.accountUuid}
            onChange={(e) => handleInputChange("accountUuid", e.target.value)}
            placeholder="12345678-abcd-1234-efgh-123456789012"
            disabled={loading}
            autoComplete="username"
            data-lpignore="false"
            spellCheck="false"
          />
        </div>

        {/* Bearer Token */}
        <div className="form-group">
          <label htmlFor="bearer-token">Bearer Token:</label>
          <input
            id="bearer-token"
            name="password"
            type="password"
            value={config.bearerToken}
            onChange={(e) => handleInputChange("bearerToken", e.target.value)}
            placeholder="Fügen Sie hier Ihren Bearer Token ein..."
            disabled={loading}
            autoComplete="current-password"
            spellCheck="false"
          />
        </div>

        {/* Status */}
        <div className="form-group">
          <label>Status:</label>
          <div
            style={{
              padding: "12px 16px",
              display: "flex",
              alignItems: "center",
              fontSize: "1rem",
              fontWeight: "500",
              color: "var(--text-color)",
            }}
          >
            <span className={`status-indicator ${getStatusClass()}`}></span>
            {getStatusText()}
          </div>
        </div>
      </div>

      {/* Test Button und Info */}
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <button
          className="btn btn-primary"
          onClick={onTest}
          disabled={
            !config.accountUuid ||
            !config.bearerToken ||
            loading
          }
          style={{ minWidth: "160px" }}
          type="button"
        >
          {loading ? "Teste..." : "Verbindung testen"}
        </button>

        <div
          style={{
            fontSize: "0.9rem",
            color: "var(--text-bg-color)",
            fontStyle: "italic",
          }}
        >
          API-Daten werden verschlüsselt in der Browser-Sitzung gespeichert
        </div>
      </div>

      {/* Hilfe-Info */}
      {!testResult && (
        <div
          style={{
            marginTop: "16px",
            padding: "12px",
            background: "var(--text-bg-color)",
            opacity: "0.1",
            borderRadius: "8px",
            fontSize: "0.9rem",
            lineHeight: "1.4",
            color: "var(--text-color)",
          }}
        >
          <strong>Sicherheit: </strong>
          Ihr Bearer Token wird verschlüsselt gespeichert und ist nur für die API-Kommunikation
          zugänglich.
          <br />
          <br />
          <strong>Hilfe: </strong>
          Die API-Zugangsdaten finden Sie in Ihrem AbaNinja-Account unter
          Einstellungen → API-Zugang. Die Account UUID steht in der URL Ihres
          AbaNinja-Dashboards.
        </div>
      )}
    </div>
  );
};

export default ConfigPanel;